import { getHostOrigin } from "./host";
import { packGuest, unpackHost, type GuestMessage, type HostMessage } from "./protocol";

/**
 * Envio e recebimento de mensagens do host. Sem React — o AuthProvider precisa
 * avisar sobre login antes de qualquer tela montar.
 *
 * Fora do modo embed tudo vira no-op, então o chamador não precisa perguntar.
 */

export function postToHost(message: GuestMessage): void {
  const origin = getHostOrigin();
  if (!origin) return;
  // targetOrigin explícito, nunca "*": com o curinga qualquer página que
  // consiga embutir este portal leria a rota e o menu do usuário.
  window.parent.postMessage(packGuest(message), origin);
}

/** Retorna a função de cancelamento. */
export function subscribeToHost(handler: (message: HostMessage) => void): () => void {
  const origin = getHostOrigin();
  if (!origin) return () => {};

  const onMessage = (event: MessageEvent) => {
    if (event.origin !== origin) return;
    if (event.source !== window.parent) return;
    const message = unpackHost(event.data);
    if (message) handler(message);
  };

  window.addEventListener("message", onMessage);
  return () => window.removeEventListener("message", onMessage);
}
